## Spring Boot

The Spring Boot plugin provides the capability interact with [actuator](https://docs.spring.io/spring-boot/docs/current/reference/html/production-ready-endpoints.html) endpoints exposed by an application.

### Health

Displays the current health status of the application together with details returned from any Spring Boot health checks.

### Info

Displays relevant information regarding the Spring boot application. It is the output of the Info actuator endpoint.

### Loggers

Lists all the available loggers in the application. You can modify the level of a logger and the changes will take effect immediately.

### Trace

Lists any HTTP traces for your application and lets you view information about the request / response such as headers, time taken etc.
